export const DETAIL_DRAWER_DISMISS_DISTANCE = 120;
export const DETAIL_DRAWER_DISMISS_VELOCITY = 0.65;

export function getDetailDrawerDragOffset(startY: number, currentY: number) {
  return Math.max(0, currentY - startY);
}

export function shouldDismissDetailDrawer(offset: number, elapsedMs: number) {
  const velocity = offset / Math.max(elapsedMs, 1);
  return (
    offset >= DETAIL_DRAWER_DISMISS_DISTANCE ||
    velocity >= DETAIL_DRAWER_DISMISS_VELOCITY
  );
}
